import api from './api';

const announcementsService = {
  async getActive() {
    const response = await api.get('/announcements/active');
    // 204 = sem anúncio ativo
    if (response.status === 204) return null;
    return response.data;
  },
};

export default announcementsService;
